import React from 'react';

import { Accordion } from '../../index';
import { useSiteQuery } from '../../../hooks';

import query from './faqs.graphql';
import FAQsForm from './form';

import styles from './styles.module.scss';
import cc from "classcat";

interface Props {
  fragment?: FaqsBlockFragment;
  topic?: string;
}

const FAQs = ({ fragment, topic }: Props) => {
  const [{ data }] = useSiteQuery<FaqsQuery>({
    query,
    variables: { search: `topic:${fragment?.topic?.[0]?.slug || topic}` },
  });
  const items = data?.items;

  if (items) {
    return (
      <div id="faqs" className={cc([styles.faqs,'saSection'])}>

        <div className="saContainer">
          <div className={styles.faqsContent}>
            <div>
              <div className="sectionHeading">
                FREQUENTLY ASKED QUESTIONS
              </div>
              <h2>
                Have a question?
              </h2>
              <FAQsForm />
              <p>
                Find more answers on our <a href="/help-centre" title="Click to visit help centre">FAQs</a> page
              </p>
            </div>
            <div>
              {items?.map(
                (item) =>
                  item && (
                    <Accordion key={item!.title!} title={item!.title!}>
                      <div dangerouslySetInnerHTML={{ __html: item!.body! }} />
                    </Accordion>
                  ),
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default FAQs;
